import { render } from "./SynchroPER.vue?vue&type=template&id=4d39b41f"
import script from "./SynchroPER.vue?vue&type=script&lang=js"
export * from "./SynchroPER.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__